import { useMediaAssetUrl } from '../../api/media-assets';

/**
 * Shows an uploaded image (`media_assets`) at a fixed square size, with a
 * neutral placeholder while loading or when there is no image.
 */
export function AssetImage({
  assetId,
  alt,
  size = 48,
}: {
  assetId: string | null | undefined;
  alt: string;
  size?: number;
}) {
  const url = useMediaAssetUrl(assetId);
  const box = {
    width: size,
    height: size,
    borderRadius: 'var(--radius-md)',
    flexShrink: 0,
  } as const;
  if (!url) {
    return (
      <span
        aria-hidden={!assetId}
        role={assetId ? 'img' : undefined}
        aria-label={assetId ? alt : undefined}
        style={{
          ...box,
          display: 'inline-block',
          background: 'var(--color-surface-muted)',
          border: '1px solid var(--color-border)',
        }}
      />
    );
  }
  return <img src={url} alt={alt} style={{ ...box, objectFit: 'cover' }} />;
}
